import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignoSeguridadService } from '@services/seguridad/signo-seguridad.service';
import { SEGURIDAD_COMPONENTES, SeguridadComponenteMeta } from '../diccionario/seguridad-diccionario';
import { coincideFuzzy } from '@shared/utils/fuzzy-search.util';

@Component({
    selector: 'app-menu-seguridad',
    templateUrl: './menu-seguridad.component.html',
    styleUrls: ['./menu-seguridad.component.scss'],
})
export class MenuSeguridadComponent implements OnInit {

    componentes: SeguridadComponenteMeta[] = SEGURIDAD_COMPONENTES;
    componentesFiltrados: SeguridadComponenteMeta[] = SEGURIDAD_COMPONENTES;
    termino: string = '';
    flagLoaded: boolean = false;

    constructor(
        private signoSeguridadService: SignoSeguridadService,
        private router: Router,
    ) {}

    async ngOnInit(): Promise<void> {
        if (!(await this.signoSeguridadService.puedeAccederSeguridad())) {
            this.signoSeguridadService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }
        this.componentesFiltrados = this.componentes;
        this.flagLoaded = true;
    }

    aplicarFiltro(termino: string): void {
        this.termino = termino;
        if (!termino || !termino.trim()) {
            this.componentesFiltrados = this.componentes;
            return;
        }
        this.componentesFiltrados = this.componentes.filter((c) =>
            coincideFuzzy(`${c.titulo} ${c.descripcion}`, termino),
        );
    }

    entrar(componente: SeguridadComponenteMeta): void {
        this.router.navigateByUrl(componente.ruta);
    }
}
